import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, dt } from "@/lib/api";
import { Panel } from "@/components/tam/ui";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

const FIELDS = [
  ["contact_name", "Contact name"], ["job_title", "Job title"], ["email", "Email"], ["company", "Company"],
  ["tel", "Telephone"], ["mobile", "Mobile"], ["address", "Address"], ["postcode", "Postcode"],
];

export function ContactForm({ account, canEdit, onSaved }) {
  const [form, setForm] = useState(() => Object.fromEntries(FIELDS.map(([k]) => [k, account.contact?.[k] || (k === "company" ? account.name : "")])));
  const [busy, setBusy] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.put(`/accounts/${account.id}/contact`, form);
      toast.success(data.changed ? `Contact qualified (${data.changed} field changes logged)` : "No changes to save");
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Panel title="Qualify contact information" testId="contact-panel">
      <form onSubmit={save} className="grid sm:grid-cols-2 gap-4">
        {FIELDS.map(([k, label]) => (
          <div key={k} className={`space-y-1.5 ${k === "address" ? "sm:col-span-2" : ""}`}>
            <Label htmlFor={k} className="text-xs text-slate-600">{label}</Label>
            <Input id={k} value={form[k]} disabled={!canEdit} type={k === "email" ? "email" : "text"}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`contact-${k}-input`} />
          </div>
        ))}
        <div className="sm:col-span-2 flex items-center justify-between gap-3 pt-2">
          <p className="text-xs text-slate-500" data-testid="contact-qualified-meta">
            {account.contact?.qualified_by ? `Last qualified by ${account.contact.qualified_by} · ${dt(account.contact.qualified_at)}` : "Not yet qualified"}
          </p>
          {canEdit && <Button type="submit" disabled={busy} className="bg-[#0B132B] hover:bg-[#1c2647]" data-testid="contact-save-btn">{busy ? "Saving…" : "Save contact"}</Button>}
        </div>
      </form>
    </Panel>
  );
}
